import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import useClickOutsideRef from '../../hooks/useClickOutsideRef';

import styles from './phoneInfoPopup.scss';

const PhoneInfoPopup = ({ email, phone, homeClub, playerId, showEditContacts }) => {
    const [showTelephonePopup, setShowTelephonePopup] = useState(false);

    const handleTelephoneClick = (e) => {
        e.preventDefault();
        setShowTelephonePopup(!showTelephonePopup);
    };

    const wrapperRef = useRef(null);
    useClickOutsideRef(wrapperRef, () => setShowTelephonePopup(false));

    return (
        <div className="position-relative ml8 fs14 b2" ref={wrapperRef} data-testid="phone-info-popup">
            <i className="fas fa-phone" onClick={handleTelephoneClick} data-testid="phone-info-popup.trigger" />
            {showTelephonePopup && (
                <div className={styles.telephonePopup} onClick={e => e.stopPropagation()} data-testid="phone-info-popup.popup">
                    <span className={styles.iconContainer} onClick={handleTelephoneClick} data-testid="phone-info-popup.close-btn"><i className="fas fa-times-circle" /></span>
                    <span className="w-100 pl-2 pt-2">
                        <span className="w-100 d-flex flex-row justify-content-between align-items-center">
                            <p>
                                <span className="text-dark">Phone:</span> {phone ? <a href={`tel:${phone}`} className="text-teal" data-testid="phone-info-popup.phone-link">{phone}</a> : 'n/a'}
                                {showEditContacts && (<Link to="/settings/account" className={styles.editIcon} data-testid="phone-info-popup.edit-phone-link" />)}
                            </p>
                            <p />
                        </span>
                        <span className="w-100 d-flex flex-row justify-content-between align-items-center">
                            <p>
                                <span className="text-dark">Email:</span> {email ? <a href={`mailto:${email}`} className="text-teal" data-testid="phone-info-popup.email-link">{email}</a> : 'n/a'}
                                {showEditContacts && (<Link to="/settings/account" className={styles.editIcon} data-testid="phone-info-popup.edit-email-link" />)}
                            </p>
                            <p />
                        </span>
                        <span className="w-100 d-flex flex-row justify-content-between align-items-center">
                            <p onClick={e => e.preventDefault()}><span className="text-dark">Home Club:</span> {homeClub || 'n/a'}
                                {showEditContacts && (<Link to={`/profiles/${playerId}/edit`} className={styles.editIcon} data-testid="phone-info-popup.edit-club-link" />)}
                            </p>
                            <p />
                        </span>
                    </span>
                </div>
            )}
        </div>
    );
};

export default PhoneInfoPopup;
